import styled from 'styled-components';

interface IProgressProps {
  percent: number;
}

export const ProgressBarContainer = styled('div')`
  width: 100%;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  border-radius: 10rem;
`;

export const ProgressBarPercent = styled('span')<IProgressProps>`
  display: block;
  position: absolute;
  right: ${(props) => (props.theme.direction === 'rtl' ? 0 : undefined)};
  left: ${(props) => (props.theme.direction === 'ltr' ? 0 : undefined)};
  background-color: ${(props) => props.color};
  background-image: ${(props) => props.color};
  color: var(--exact-white);
  padding: 5px;
  width: ${(props) => props.percent}%;
  transition: all 1s ease;
  border-radius: 10rem;
`;

export const ProgressBarBorder = styled('span')`
  display: block;
  height: 10px;
  width: 100%;
  background: rgba(0, 0, 0, 0.075);
  position: relative;
  border-radius: 10rem;
`;
